import React from "react"

const Download = ({ className }) => (
	<svg
		viewBox="0 0 16 18"
		className={`inline-block fill-current align-middle ${className}`}
		xmlns="http://www.w3.org/2000/svg">
		<path d="m9 10.586 4.293-4.293 1.414 1.414L8 14.414 1.293 7.707l1.414-1.414L7 10.586V0h2v10.586ZM16 16v2H0v-2h16Z" />
	</svg>
)

export default Download
